<app-page-container>
  <div class="forgetHeader">
    <span
      ><b>{{ 'forgotPassword' | translate }}</b></span
    >
  </div>

  <dx-form class="forgetForm" #forgetForm [minColWidth]="350" [formData]="forgetFormData">
    <dxi-item dataField="benutzername" [label]="{ text: 'loginUsername' | translate }" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 50 }">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <!-- <dxi-validation-rule type="email" message="{{ 'wrongMail' | translate }}"></dxi-validation-rule>
      <dxi-validation-rule type="pattern" [pattern]="configService.emailPattern" message="{{ 'wrongMail' | translate }}"></dxi-validation-rule> -->
    </dxi-item>
  </dx-form>

  <span class="msg-text color-error" *ngIf="msg !== ''">{{ msg }}</span>
  <div class="message-container" *ngIf="isSended">
    <span class="msg-text color-success">{{ 'sendNewPassword' | translate }}</span>
    <span class="msg-text color-success" style="font-size: small"
      >{{ 'redirectToStartpage_1' | translate }}{{ cntDown }}{{ 'redirectToStartpage_2' | translate }}</span
    >
  </div>

  <dx-toolbar class="forgetToolbar">
    <dxi-item
      widget="dxButton"
      location="after"
      toolbar="bottom"
      [options]="{
        disabled: isSending || isSended,
        text: 'request' | translate,
        onClick: onClickForget,
        type: 'default',
        icon: 'startswith',
        stylingMode: 'filled'
      }"
    >
    </dxi-item>

    <dxi-item
      widget="dxButton"
      location="befor"
      toolbar="bottom"
      [options]="{ disabled: isSending, text: 'cancel' | translate, onClick: onClickReset, type: 'default', icon: 'remove', stylingMode: 'filled' }"
    >
    </dxi-item>
  </dx-toolbar>

  <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#forgetForm' }"
    [(visible)]="isSending"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
    message="Daten werden versendet..."
  >
  </dx-load-panel>
</app-page-container>
